import { section } from './section.js';
import { monitor } from './monitor.js';
import { notification } from './notification.js';
import { instances } from './instances.js';
import { reports } from './reports.js';
import { theme } from './theme.js';
import { stateTreeSettings } from './stateTreeSettings.js';
export const coreReducers = {
    section,
    theme,
    stateTreeSettings,
    monitor,
    instances,
    reports,
    notification,
};
